// extracted by mini-css-extract-plugin
export default {"gridForm":"SinglePageForm_gridForm__9OCiO","gridButtons":"SinglePageForm_gridButtons__qx1jr","acceptTerms":"SinglePageForm_acceptTerms__bG8Nj","error":"SinglePageForm_error__OcZRT"};